import React from 'react';
import useDevToolsDetection from '../hooks/useDevToolsDetection';

const DevToolsBlocker = () => {
    const isDevToolsOpen = useDevToolsDetection();

    if (!isDevToolsOpen) return null;

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                zIndex: 999999,
                backgroundColor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
            }}
        >
            <div
                style={{
                    textAlign: 'center',
                    padding: '40px',
                    maxWidth: '480px',
                    borderRadius: '12px',
                    boxShadow: '0 4px 32px rgba(0,0,0,0.12)',
                    border: '1px solid #e5e7eb',
                    backgroundColor: '#fff',
                }}
            >
                {/* Warning icon */}
                <div
                    style={{
                        width: '72px',
                        height: '72px',
                        borderRadius: '50%',
                        backgroundColor: '#FEF3C7',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px',
                    }}
                >
                    <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#D97706"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                        <line x1="12" y1="9" x2="12" y2="13" />
                        <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                </div>

                <h2
                    style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#111827',
                        marginBottom: '12px',
                        fontFamily: 'system-ui, sans-serif',
                    }}
                >
                    Developer Tools Detected
                </h2>

                <p
                    style={{
                        fontSize: '15px',
                        color: '#6B7280',
                        lineHeight: '1.6',
                        fontFamily: 'system-ui, sans-serif',
                        marginBottom: '8px',
                    }}
                >
                    Please close your browser&apos;s Developer Tools to continue
                    using this application.
                </p>

                <p
                    style={{
                        fontSize: '13px',
                        color: '#9CA3AF',
                        fontFamily: 'system-ui, sans-serif',
                    }}
                >
                    The page will resume automatically once DevTools are closed.
                </p>
            </div>
        </div>
    );
};

export default DevToolsBlocker;
